import { Component, ChangeDetectionStrategy, ElementRef, Renderer2 } from '@angular/core';
import { OGKushBusinessCardStackContentViewModel } from './og-kush-business-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-og-kush-business-card-stack-content',
  templateUrl: './og-kush-business-card-stack-content.component.html',
  styleUrls: ['./og-kush-business-card-stack-content.component.scss'],
  providers: [OGKushBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OGKushBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: OGKushBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
